import LeafletMap from "./LeafletMap";

export default LeafletMap;
